import { cloneDeep } from 'lodash';

import ClipArtToolPopover from '@/components/ToolPopovers/ClipArt';

import {
  CLIP_ART_TYPE,
  EVENT_TYPE,
  PER_PAGE_10,
  SAVED_CLIP_ART_TYPE
} from '@/common/constants';
import { useClipArt } from '@/views/CreateBook/composables';
import { useGenerateClipart, usePopoverCreationTool } from '@/hooks';

export default {
  components: {
    ClipArtToolPopover
  },
  data() {
    return {
      category: 0,
      clipArtList: [],
      selectedClipArtId: [],
      displayClipArtTypes: [],
      chosenClipArtType: { value: '', sub: '' },
      isLoadingCategory: true,
      perPages: PER_PAGE_10,
      currentPage: 1,
      isLoadingCliparts: true,
      currentPageItem: 1
    };
  },
  setup() {
    const {
      searchClipArt,
      getClipArtList,
      loadClipArtCategories
    } = useClipArt();
    const { setToolNameSelected } = usePopoverCreationTool();
    const { getGeneratedClipart } = useGenerateClipart();

    return {
      searchClipArt,
      getClipArtList,
      loadClipArtCategories,
      setToolNameSelected,
      getGeneratedClipart
    };
  },
  methods: {
    /**
     * Add clip art id to array clip art selected
     */
    selectClipArt(clipArt) {
      if (this.selectedClipArtId.includes(clipArt.id)) {
        this.selectedClipArtId = this.selectedClipArtId.filter(
          item => item !== clipArt.id
        );
      } else {
        this.selectedClipArtId = [...this.selectedClipArtId, clipArt.id];
      }
    },
    /**
     * Set tool name selected is empty to close popover after click Cancel button
     */
    onCancel() {
      this.setToolNameSelected('');
      this.selectedClipArtId = [];
    },
    /**
     * Add clip art on Canvas and close popover after click Select button
     */
    addClipArts() {
      const addClipArts = this.clipArtList.filter(item => {
        return this.selectedClipArtId.includes(item.id);
      });
      this.$root.$emit(EVENT_TYPE.ADD_CLIPARTS, cloneDeep(addClipArts));
      this.onCancel();
    },
    /**
     * Change clip art type when selected
     * @param {Object} clipArtType - Clip art type and category selected
     */
    async onChangeClipArtType(clipArtType) {
      this.clipArtList = [];
      this.currentPageItem = 1;
      this.isLoadingCliparts = true;
      if (clipArtType.sub.value)
        this.clipArtList = await this.getClipArts(
          clipArtType.sub.value,
          this.currentPageItem
        );

      this.chosenClipArtType = {
        value: clipArtType.value,
        sub: clipArtType.sub.value
      };

      this.selectedClipArtId = [];
    },
    /**
     * Get clip art type from api
     */
    async clipArtTypes() {
      const categories = await this.loadClipArtCategories(
        this.currentPage,
        false
      );
      const CLIP_ART_CATEGORIES = [SAVED_CLIP_ART_TYPE, ...categories];
      this.category = CLIP_ART_CATEGORIES[0].id;
      return Object.keys(CLIP_ART_TYPE).map(k => {
        const clType = {
          ...CLIP_ART_TYPE[k],
          value: CLIP_ART_TYPE[k].id,
          subItems: []
        };
        if (CLIP_ART_TYPE[k].id === 0) {
          clType.subItems = Object.keys(CLIP_ART_CATEGORIES).map(key => {
            return {
              ...CLIP_ART_CATEGORIES[key],
              value: CLIP_ART_CATEGORIES[key].id
            };
          });
        }
        return clType;
      });
    },
    /**
     * To search base on value input
     * @param {String}  input value to search
     */
    async onSearch(input) {
      this.isLoadingCliparts = false;
      this.selectedClipArtId = [];
      this.clipArtList = await this.searchClipArt(input);
    },
    async onLoadMoreCategory() {
      if (this.currentPage > 0) {
        this.currentPage++;
        const clipArtCategories = await this.loadClipArtCategories(
          this.currentPage,
          true
        );
        if (clipArtCategories.length < this.perPages) {
          this.isLoadingCategory = false;
          this.currentPage = -1;
        }
        this.displayClipArtTypes[0].subItems = [
          ...this.displayClipArtTypes[0].subItems,
          ...clipArtCategories.map(c => {
            return { ...c, value: c.id };
          })
        ];

        this.displayClipArtTypes[0].subItems = [
          this.displayClipArtTypes[0].subItems[0],
          ...this.displayClipArtTypes[0].subItems
            .slice(1)
            .sort((item1, item2) => item1.name.localeCompare(item2.name))
        ];
      }
    },
    async getClipArts(categoryId, page, hideSpiner) {
      if (categoryId === SAVED_CLIP_ART_TYPE.value) {
        return this.getGeneratedClipart(page, hideSpiner);
      } else {
        return this.getClipArtList(categoryId, page, hideSpiner);
      }
    },
    async onLoadMoreCliparts() {
      if (this.currentPageItem < 0) {
        this.isLoadingCliparts = false;
        return;
      }
      this.currentPageItem++;
      const extraCliparts = await this.getClipArts(
        this.chosenClipArtType.sub,
        this.currentPageItem,
        true
      );
      this.clipArtList = [...this.clipArtList, ...extraCliparts];
      if (extraCliparts.length < this.perPages) {
        this.isLoadingCliparts = false;
        this.currentPageItem = -1;
      }
    }
  },
  async created() {
    const clipArtTypes = await this.clipArtTypes();
    this.clipArtList = await this.getClipArts(
      this.category,
      this.currentPageItem
    );

    this.displayClipArtTypes = clipArtTypes.filter(
      b => b.id !== CLIP_ART_TYPE.FAVORITE.id
    );

    if (this.displayClipArtTypes.length === 0) return;

    this.chosenClipArtType = {
      value: this.displayClipArtTypes[0].id,
      sub: this.displayClipArtTypes[0].subItems[0].id
    };
  }
};
